export default __webpack_public_path__ + "static/media/12_Intimacy.2b5353b7.jpg";